import {equals, isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

import {type FiltersType} from '../types/FiltersType';
import {type ClassifiedsRequestInput} from './omitHiddenVanFilters';

type Params = {
  filters: FiltersType;
  filterPresetId: string | Nullish;
  presetFilters: FiltersType | Nullish;
  isSuspiciousVehiclesEnabled: boolean;
  isSuspiciousReasonFilterEnabled: boolean;
};

/** A preset id overrides the request body, so drop it when its suspicious filter differs. */
export const omitHiddenSuspiciousReasonFilter = ({
  filters,
  filterPresetId,
  presetFilters,
  isSuspiciousVehiclesEnabled,
  isSuspiciousReasonFilterEnabled,
}: Params): ClassifiedsRequestInput => {
  const applicableFilters: FiltersType = {
    ...filters,
    hideSuspicious: isSuspiciousVehiclesEnabled && filters.hideSuspicious,
    excludeSuspiciousReasons: isSuspiciousReasonFilterEnabled
      ? filters.excludeSuspiciousReasons
      : undefined,
  };
  const presetDiffers =
    isNotNil(presetFilters) &&
    (Boolean(applicableFilters.hideSuspicious) !== Boolean(presetFilters.hideSuspicious) ||
      !equals(applicableFilters.excludeSuspiciousReasons, presetFilters.excludeSuspiciousReasons));

  return {
    filters: applicableFilters,
    filterPresetId: presetDiffers ? null : filterPresetId,
  };
};
